import React from 'react';
import { ModalsKeys } from 'global';
import { PageContainer } from 'components/shared/Page/PageContainer';

import { CustomerAccountDialog } from '../../dialogs';
import { CustomersListCard } from './CustomersListCard';

export const CustomersListPage = () => {
  return (
    <PageContainer title="Customers" modals={{ [ModalsKeys.CustomerAccountDialog]: <CustomerAccountDialog /> }}>
      <CustomersListCard />
    </PageContainer>
  );
};
